import { render, staticRenderFns } from "./BtnDelete.vue?vue&type=template&id=c026b09a&scoped=true&"
import script from "./BtnDelete.vue?vue&type=script&lang=js&"
export * from "./BtnDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c026b09a",
  null
  
)

export default component.exports